import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Subscriptions from './subscriptions';
import Invoices from './invoices';

const UI = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Route
                path={`${match.url}/subscription`}
                component={Subscriptions}
            />
            <Route
                path={`${match.url}/invoice`}
                component={Invoices}
            />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default UI;